import {
  StickyNote, CheckSquare, BellRing, CalendarClock, Eye, BookOpen,
} from "lucide-react";

export const TYPE_META = {
  NOTE: { label: "Note", icon: StickyNote },
  TASK: { label: "Task", icon: CheckSquare },
  REMINDER: { label: "Reminder", icon: BellRing },
  CALENDAR_SUGGESTION: { label: "Calendar", icon: CalendarClock },
  LATER: { label: "Later", icon: Eye },
  JOURNAL: { label: "Journal", icon: BookOpen },
};

export const DOMAIN_META = {
  WORK: { label: "Work", cls: "bg-[var(--pine-soft)] text-[var(--pine)] border-[var(--pine-line)]" },
  PERSONAL: { label: "Personal", cls: "bg-[var(--slate-soft)] text-[var(--slate)] border-[var(--pine-line)]" },
  FAMILY: { label: "Family", cls: "bg-[var(--line2)] text-[var(--ink2)] border-[var(--line)]" },
  ADMIN: { label: "Admin", cls: "bg-[var(--line2)] text-[var(--ink3)] border-[var(--line)]" },
  PROSPECT: { label: "Prospect", cls: "bg-[var(--slate-soft)] text-[var(--slate)] border-[var(--pine-line)]" },
};

// Amber is reserved strictly for due / overdue / resurfacing.
export const URGENCY_META = {
  OVERDUE: { label: "Overdue", cls: "bg-[var(--amber-soft)] text-[var(--amber)] border-transparent" },
  NOW: { label: "Now", cls: "bg-[var(--amber-soft)] text-[var(--amber)] border-transparent" },
  TODAY: { label: "Today", cls: "bg-[var(--amber-soft)] text-[var(--amber)] border-transparent" },
  THIS_WEEK: { label: "This week", cls: "bg-[var(--line2)] text-[var(--ink3)] border-transparent" },
  LATER: { label: "Later", cls: "bg-[var(--line2)] text-[var(--ink3)] border-transparent" },
};

export const TYPE_BADGE_CLS = "bg-[var(--line2)] text-[var(--ink2)] border-[var(--line)]";

export const OWNER_META = {
  me: { label: "Me", cls: "bg-[var(--pine-soft)] text-[var(--pine)] border-[var(--pine-line)]" },
  partner: { label: "Partner", cls: "bg-[var(--slate-soft)] text-[var(--slate)] border-[var(--pine-line)]" },
  shared: { label: "Shared", cls: "bg-[var(--pine-soft)] text-[var(--pine)] border-[var(--pine-line)]" },
};

export const VISIBILITY_META = {
  private: { label: "Private" },
  shared: { label: "Household" },
};

export const OWNER_OPTIONS = Object.keys(OWNER_META);
export const VISIBILITY_OPTIONS = Object.keys(VISIBILITY_META);

export const TYPE_OPTIONS = Object.keys(TYPE_META);
export const URGENCY_OPTIONS = Object.keys(URGENCY_META);
export const DOMAIN_OPTIONS = Object.keys(DOMAIN_META);
// Household cohort: "Prospect" is a work-only category and is not surfaced.
export const HOUSEHOLD_DOMAIN_OPTIONS = DOMAIN_OPTIONS.filter((d) => d !== "PROSPECT");

// Single source of truth for the handoff action label/state, shared by the card
// overflow menu (QuickEdit) and the detail sheet so both surfaces stay in sync.
// Keys off the backend's existing signals (owner + is_handoff): when the viewer
// holds an item the partner handed to them (owner "me" + is_handoff), giving it
// to the partner is a RETURN -> "Give back to {partner}". Items on the partner's
// plate -> "Take it back". Otherwise a plain "Give to {partner}".
export function handoffAction(entry, partnerName) {
  const name = partnerName || "your partner";
  if (entry.owner === "partner") {
    return { action: "me", label: "Take it back", kind: "takeback" };
  }
  if (entry.owner === "me" && entry.is_handoff) {
    return { action: "partner", label: `Give back to ${name}`, kind: "giveback" };
  }
  return { action: "partner", label: `Give to ${name}`, kind: "give" };
}


export function fmtDateTime(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    weekday: "short", month: "short", day: "numeric",
    hour: "numeric", minute: "2-digit",
  });
}

export function fmtTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleString(undefined, {
    month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
  });
}
